import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';

export const consts = createReqConsts('programs', 'invitations', [
  'REMOVE_INVITATION',
  'ACCEPT',
  'DECLINE',
  'CLEAR',
]);

export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'program_invitations',
  ],
  type: 'get',
});

const requestReducer = createReqReducer(consts);

const removeInvitation = (state, { id }) => {
  state.list.splice(state.list.findIndex(item => item.id === id), 1);

  return {
    ...state,
    list: [...state.list],
  };
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case consts.ACCEPT:
    case consts.DECLINE:
      return state; // Do nothing. Saga is watching these action
    case consts.REMOVE_INVITATION:
      return removeInvitation(state, payload);
    case consts.CLEAR:
      return initialState;

    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/programs/invitations.js